import { CurrencyMaskConfig } from 'src/lib/ngx-currency/src/currency-mask.config';

export const currencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: '.',
  nullable: true,
  precision: 2,
  prefix: '',
  suffix: '',
  thousands: ',',
};
